import { PlayerSizesTypes } from '../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { removeHighlights } from '../styles';

interface StylesObject {
  closeIconStyle: { [key: string]: any };
}

const getCloseIconStyle = (playerSize, showCloseIcon) => {
  let style = {};
  style = {
    position: 'absolute',
    ...removeHighlights,
    color: SITE_VARIABLES.COLORS.WHITE,
    cursor: 'pointer',
    top: '6px',
    right: '0',
    pointerEvents: 'auto' };

  switch (playerSize) {
    case 'small':
      style = { ...style,
        height: '16px',
        width: '16px',
        minWidth: '16px',
        marginRight: '4px',
      };
      break;
    case 'medium':
      style = { ...style,
        height: '20px',
        width: '20px',
        minWidth: '20px',
        marginRight: '8px',
      };
      break;
    case 'large':
      style = { ...style,
        height: '16px',
        width: '16px',
        minWidth: '16px',
        marginRight: '8px',
      };
      break;
    case 'extraLarge':
      style = { ...style,
        height: '20px',
        width: '20px',
        minWidth: '20px',
        marginRight: '16px',
      };
      break;
    default:
      break;
  }
  if (!showCloseIcon) {
    style = { ...style, display: 'none' };
  }

  return style;
};

export const getCloseButtonStyleObject = (playerSize: PlayerSizesTypes, showCloseIcon: boolean): StylesObject => {
  return ({
    closeIconStyle: [
      getCloseIconStyle(playerSize, showCloseIcon),
    ],
  });
};
